import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/tenant-feature-item.dto';

export * from './enums/tenant-feature-item-type.enum';

export * from './validators/schemas/tenant-feature-item.schema';

export const tenantFeatureItemValidators = { canCreateOrUpdate };
